<template>
  <div class="pathwayPlace">
    <div class="placeContainer">
      <div class="pathwayList">
        <van-cell-group v-for="(item, index) in pathwayList" :key="index">
          <van-field @click.prevent="fieldClick" @blur="onBlurairportName($event, index)" v-model="item.useLocation"
            :label="`途径点${index + 1}`" placeholder="请输入详细地址">
            <template #button>
              <van-icon @click="deletePathwayPlace(index)" name="delete-o" style="font-size: 16px" />
            </template>
          </van-field>
        </van-cell-group>
        <div class="addBtn">
          <div @click.stop="addPathwayPlace">
            <img src="@/assets/car/push.png" alt="" />
          </div>
        </div>
      </div>
      <div class="footerBtn">
        <div>
          <van-button @click="cancel" type="default" size="small" style="width: 30%">取消</van-button>
          <van-button type="info" size="small" @click="confirmAdd"
            style="width: 70%; background-color: #4ea27c">确定</van-button>
        </div>
      </div>
      <div id="container" style="overflow: hidden"></div>
    </div>
  </div>
</template>

<script>
// import coordtransform from "coordtransform";
import "@/assets/car/icon/iconfont.css";
// import AMapLoader from "@amap/amap-jsapi-loader";
// window._AMapSecurityConfig = {
//   securityJsCode: "d7dd8082c27cd068108a8e1b6aed837f"
// };
// const asyncJS = src => {
//   var jsapi = document.createElement("script");
//   jsapi.charset = "utf-8";
//   jsapi.src = src;
//   document.head.appendChild(jsapi);
// };
export default {
  name: "pathwayPlace",
  data() {
    return {
      pathwayList: [
        {
          useLocation: ""
        }
      ],
      location: [],
      map: null,
      mapMark: null,
      longAndLat: "",
      btnloading: false,
      isShowUserId:false
    };
  },
  components: {
    // demo
  },
  created() {
    let addressInfoList = sessionStorage.getItem("addressInfoList")
   
      ? JSON.parse(sessionStorage.getItem("addressInfoList"))
      : [];
    console.log("addressInfoList", addressInfoList);
    if (addressInfoList.length > 0) {
      this.pathwayList = addressInfoList;
      // this.location = addressInfoList;
    }
  },
  mounted() {
    this.isShowUserId = sessionStorage.getItem("isShowUserId")
    this.keyWord = this.bmapSearMsg;
    // window.onLoadMap = () => {
    //   this.ready();
    // };
    // key 值需要去高德地图去申请才可以
    // asyncJS(
    //   "https://webapi.amap.com/maps?v=1.4.15&key=db734ee0deb249082595ed2fb6f74750&callback=onLoadMap"
    // );
  },
  methods: {
    fieldClick() {
      this.btnloading = true;
    },
    onBlurairportName(event, index) {
      if (event.target.value) {
        console.log(event.target.value, index);
        // this.search(event.target.value, index);
      }

    },
    // ready() {
    //   this.map = new window.AMap.Map("container", {
    //     resizeEnable: true
    //   });
    //   let _this = this;
    //   // 为地图注册click事件获取鼠标点击出的经纬度坐标
    //   this.map.on("click", function (e) {
    //     let lng = e.lnglat.getLng();
    //     let lat = e.lnglat.getLat();
    //     _this.longAndLat = lng + "," + lat;
    //     // 打新的标记
    //     _this.addMarker(lng, lat);
    //   });
    // },
    // search(val, index) {
    //   // 创建地理编码器实例
    //   // var geocoder = new BMap.Geocoder();
    //   // // 地理编码
    //   // geocoder.getPoint(val, (point) => {
    //   //   if (point) {
    //   //     var lng = point.lng; // 经度
    //   //     var lat = point.lat; // 纬度
    //   //     console.log("经纬度：" + lng + ", " + lat);
    //   //     let obj = {
    //   //       useLocation: val,
    //   //       longitude: lng,
    //   //       dimension: lat
    //   //     }
    //   //     this.location[index] = obj;
    //   //     this.btnloading = false
    //   //   } else {
    //   //     this.$toast("无法获取到地址的经纬度")
    //   //   }
    //   // }, '中国');
    //   let _this = this;
    //   window.AMap.plugin("AMap.PlaceSearch", () => {
    //     var autoOptions = {
    //       city: "全国",
    //       map: _this.map, // 展现结果的地图实例
    //       pageSize: 1, // 单页显示结果条数
    //       pageIndex: 1, // 页码
    //       autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
    //     };
    //     var placeSearch = new window.AMap.PlaceSearch(autoOptions);
    //     placeSearch.search(val, (status, result) => {
    //       console.log("status, result", status, result);
    //       // 搜索成功时，result即是对应的匹配数据
    //       if (status == "complete") {
    //         if (result.poiList.pois.length > 0) {
    //           let lng = result.poiList.pois[0].location.lng;
    //           let lat = result.poiList.pois[0].location.lat;
    //           _this.longAndLat = lng + "," + lat;
    //           console.log(
    //             "国测局坐标转百度经纬度坐标",
    //             coordtransform.gcj02tobd09(lng, lat)
    //           );
    //           let obj = {
    //             useLocation: val,
    //             longitude: lng,
    //             dimension: lat
    //           };
    //           this.location[index] = obj;
    //           this.btnloading = false;
    //         } else {
    //           this.$toast("没有查询到对应的地址");
    //         }
    //       } else if (status == "no_data") {
    //         this.$toast("没有查询到对应的地址");
    //       } else {
    //         console.log(111, status);
    //         this.$toast("免费额度已用完，请购买高德地图api");
    //       }
    //     });
    //   });
    // },
    // 实例化点标记
    // addMarker(lng, lat) {
    //   // 先清除原来的标记
    //   // this.clearMarker();
    //   // 清除所有标记
    //   this.map.clearMap();
    //   let _this = this;
    //   this.mapMark = new window.AMap.Marker({
    //     position: [lng, lat],
    //     map: _this.map
    //   });
    //   this.mapMark.setMap(this.map);
    // },
    //地图
    // initMap() {
    //   AMapLoader.reset();
    //   AMapLoader.load({
    //     key: "db734ee0deb249082595ed2fb6f74750", // 申请好的Web端开发者Key，首次调用 load 时必填
    //     version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    //     plugins: [
    //       "AMap.AutoComplete",
    //       "AMap.PlaceSearch",
    //       "AMap.Geolocation",
    //       "AMap.Geocoder",
    //       "AMap.CitySearch"
    //     ] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    //   })
    //     .then(AMap => {
    //       var geocoder = new AMap.Geocoder({
    //         city: "全国"
    //       });
    //       // 根据城市获取经纬度
    //       this.pathwayList.map(item => {
    //         console.log("item", item);
    //         geocoder.getLocation(item.useLocation, (status, result2) => {
    //           console.log("1111334", item.useLocation, status, result2);
    //           if (status === "complete" && result2.geocodes.length) {
    //             this.location.push({
    //               useLocation: item.useLocation,
    //               longitude: result2.geocodes[0].location.lng,
    //               dimension: result2.geocodes[0].location.lat
    //             });
    //             const position = [
    //               result2.geocodes[0].location.lng,
    //               result2.geocodes[0].location.lat
    //             ];
    //             geocoder.getAddress(position, (status, result) => {
    //               if (status === "complete" && result.info === "OK") {
    //                 // result为对应的地理位置详细信息
    //                 console.log(result);
    //               }
    //             });
    //             let addressInfoList = JSON.stringify(this.location);
    //             // window.sessionStorage.address = address;
    //             sessionStorage.setItem("addressInfoList", addressInfoList);
    //             // this.$router.go(-1);
    //             this.$router.replace({
    //               path: `/car/${this.$route.query.keyName}/${this.$route.query.name}`
    //             });
    //           } else {
    //             console.log("sxscscss", item.useLocation, (status, result2));
    //           }
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error", e);
    //     });
    // },
    // 添加
    addPathwayPlace() {
      const filterPathway = this.pathwayList.filter(item => {
        if (item.useLocation === "") {
          this.$toast("途径点为空，不能进行添加");
          return item;
        }
      });
      console.log(filterPathway);
      if (filterPathway.length < 1) {
        const json = {
          useLocation: ""
        };
        this.pathwayList.push(json);
      }
    },
    //取消
    cancel() {
      // this.$router.push(`/car/${this.$route.query.name}`);
      this.$router.replace({
        path: `/car/${this.$route.query.keyName}/${this.$route.query.name}`
      });
    },
    //确定
    confirmAdd() {
      console.log("pathwayList", this.location, this.pathwayList);

      // if (this.location.some(item => !item.longitude)) {
      //   return this.$toast("您上方填写的地址有问题"); //
      // }
      // console.log("pathwayList", this.location.length, this.pathwayList.length);
      // if (this.pathwayList.length !== this.location.length) return;
      let addressInfoList = JSON.stringify(this.pathwayList);
      sessionStorage.setItem("addressInfoList", addressInfoList);
      this.$router.replace({
        path: `/car/${this.$route.query.keyName}/${this.$route.query.name}?isShowUserId=${this.isShowUserId}`
      });
      sessionStorage.removeItem("isShowUserId")
    },
    // 删除
    deletePathwayPlace(index) {
      if (this.pathwayList.length > 1) {
        this.pathwayList.splice(index, 1);
        this.btnloading = false;
      } else {
        this.$toast("最后一条途径点不能进行删除");
      }
      // this.location.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .pathwayPlace {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .pathwayPlace {
    width: 276px * $zoom;
  }
}

.pathwayPlace {
  margin: auto;

  .placeContainer {
    .pathwayList {
      padding: 30px 30px 100px 30px;

      ::v-deep .van-hairline--top-bottom::after {
        content: "";
        border: 0;
      }

      ::v-deep(.van-cell-group) {
        .van-cell {
          display: flex;
          flex-direction: column;
          padding: 18px 0;
        }

        .van-field__value {
          background-color: #f7f9fa;
          padding: 10px 20px;
        }

        .van-cell::after {
          content: "";
          border-bottom: 0;
        }

        .van-field__label {
          font-size: 29px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
        }

        .van-field__label {
          width: 500px !important;
        }

        .van-icon {
          font-size: 29px;
        }
      }

      .addBtn {
        // padding: 0.625rem 0 1.25rem 0;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        img {
          width: 40px;
          height: 40px;
        }
      }
    }

    @media screen and (max-width: 600px) {
      .footerBtn {
        width: 100%;
      }
    }

    @media screen and (min-width: 600px) {
      .footerBtn {
        width: 276px * $zoom;
      }
    }

    .footerBtn {
      position: fixed;
      bottom: 0;
      margin-top: 30px;

      ::v-deep(.van-button--small) {
        height: 88px;
        border-radius: 0;
        font-size: 27px;
        border: 0;
      }
    }
  }
}
</style>
